module.exports = __webpack_public_path__ + "static/hero-border-white-cbeda91566935576b0ff1a598100ac5a.svg";